import {
  Anchor as PopoverAnchorPrimitive,
  Content as PopoverContentPrimitive,
  Portal as PopoverPortalPrimitive,
  Root as PopoverRootPrimitive,
  Trigger as PopoverTriggerPrimitive,
} from '@radix-ui/react-popover';
import React from 'react';

import { cn } from '@/utils/utils';

const Popover = PopoverRootPrimitive;

const PopoverTrigger = PopoverTriggerPrimitive;

const PopoverAnchor = PopoverAnchorPrimitive;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverContentPrimitive>,
  React.ComponentPropsWithoutRef<typeof PopoverContentPrimitive>
>(({ align = 'center', className, sideOffset = 4, ...props }, ref) => (
  <PopoverPortalPrimitive>
    <PopoverContentPrimitive
      align={align}
      className={cn(
        'text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 rounded-md border bg-popover p-4 shadow-md outline-none',
        className,
      )}
      ref={ref}
      sideOffset={sideOffset}
      {...props}
    />
  </PopoverPortalPrimitive>
));
PopoverContent.displayName = PopoverContentPrimitive.displayName;

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor };
